import { all } from "redux-saga/effects";
import auth from "./auth";
import customer from "./customer";
import error from "./error";
import disclaimer from "./disclaimer";
import common from "./master";
import product from "./product";
import subscription from "./subscription";
import register from "./register";
import primaryHistory from "./history-primary";
import secondaryHistory from "./history-secondary";
import structureNoteHistory from "./history-structure-note";
import withholdTaxHistory from "./history-withholding-tax";
import pwm from "./pwm";
import buySellSwitching from "./buy-sell-switch";
import productComplex from "./product-complex";
import redirect from "./redirect";
import portfolio from "./portfolio";
import secondMarket from "./second-market";
import fund from "./fund";
import research from "./research";
import modelPortfolio from "./model-portfolio";
import structureNote from "./structure-note";
import perpBond from "./perp-bond";
import lombard from "./lombard";
import primaryPort from "./primary-port";
import notification from "./notification";
import announcement from "./announcement";

export default function* rootSaga() {
  yield all([
    ...auth,
    ...customer,
    ...error,
    ...disclaimer,
    ...common,
    ...product,
    ...subscription,
    ...register,
    ...primaryHistory,
    ...secondaryHistory,
    ...structureNoteHistory,
    ...pwm,
    ...buySellSwitching,
    ...productComplex,
    ...redirect,
    ...portfolio,
    ...secondMarket,
    ...withholdTaxHistory,
    ...fund,
    ...research,
    ...modelPortfolio,
    ...structureNote,
    ...perpBond,
    ...lombard,
    ...primaryPort,
    ...notification,
    ...announcement,
  ]);
}
